// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-hjblywxcx-index-main_right_content-zS7zS","table":"components-tjcx-hjblywxcx-index-table-23KRc"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/hjblywxcx/index.css
// module id = 2306
// module chunks = 0